<template>
  <LayoutSite>
    <Formulario titulo="Tipos de Prazo" v-if="!frmcadastro">
      <v-card-title>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="openform('novo')"
          :disabled="!permissoes.tipo_incluir"
        >Novo Tipo de Prazo</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.nome }}</td>
            <td class="text-xs-right">{{props.item.tipo_descr }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </Formulario>
    <Formulario :titulo="titulo" v-if="frmcadastro">
      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false; this.getData();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nome" name="nome" autofocus v-model="tipo.nome"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-label>Tipo de Ato</v-label>
              <v-radio-group v-model="tipo.tipoato" row>
                <v-radio label="Execução" value="1"></v-radio>
                <v-radio label="Provisão" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="error"
            @click="confirmaExcluir()"
            v-if="excluir"
            :disabled="!permissoes.tipo_excluir"
          >EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" type="submit" :disabled="!permissoes.tipo_alterar">SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir este Tipo de Prazo?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>
                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  components: {
    LayoutSite,
    Formulario
  },
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Nome", value: "nome", align: "left" },
        { text: "Tipo de Ato", value: "tipo_descr" }
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      readonly: true,
      titulo: String,
      erros: [],
      tipo: {
        id: 0,
        nome: "",
        tipoato: "1"
      },
      permissoes: {
        tipo: false,
        tipo_incluir: false,
        tipo_alterar: false,
        tipo_excluir: false
      }
    };
  },
  created: function() {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.tipo) this.$router.push("/#");
    } else this.$router.push("/#");
  },
  methods: {
    getData: function() {
      this.$http
        .get(this.$urlAPI + "/tipo", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.items = response.data));
    },
    openform: function(opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Novo Tipo de Prazo";
        this.tipo.nome = "";
        this.tipo.tipoato = "1";
        this.tipo.id = 0;
      } else if (opcao == "editar") {
        this.excluir = true;
        this.titulo = "Editar Tipo de Prazo";

        this.$http
          .get(this.$urlAPI + "/tipo/" + id, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            this.tipo = response.data;
            this.tipo.tipoato = String(this.tipo.tipoato);
          });
      }
    },
    salvar: function() {
      this.tipo.tipoato = String(this.tipo.tipoato);
      if (this.excluir) {
        this.$http
          .post(this.$urlAPI + "/tipo/" + this.tipo.id, this.tipo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/tipo", this.tipo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function() {
      this.exclusao = true;
    },
    deletar: function() {
      this.$http
        .delete(this.$urlAPI + "/tipo/" + this.tipo.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>
